import { getApi, postApi, putApi } from "./api";
import Api from "./api";

export const GET_PATIENT_LIST_API = {
  method: "GET",
  url: "/patient/get-list",
};

export const CREATE_PATIENT_API = {
  method: "GET",
  url: "/patient/duple-check",
};

export const SEARCH_PATIENT_API = {
  method: "GET",
  url: "/patient/get-list",
};

export const GET_PATIENT_INFO_API = {
  method: "GET",
  url: "/patient/getDiagnosis",
};

export const REGISTER_PATIENT_API = {
  method: "POST",
  url: "/patient/register",
};

export const getPatientList = async (doctorId) => {
  try {
    const response = await getApi(GET_PATIENT_LIST_API.url, { doctorId });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const createPatient = async ({ doctorId, patientCode }) => {
  try {
    const response = await getApi(CREATE_PATIENT_API.url, {
      doctorId,
      patientCode,
    });
    console.log("response ->", response);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const searchPatient = async ({ doctorId, code }) => {
  try {
    const response = await getApi(SEARCH_PATIENT_API.url, { doctorId, code });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getPatientInfo = async ({ patientId }) => {
  try {
    const response = await getApi(`${GET_PATIENT_INFO_API.url}/${patientId}`);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const registerPatient = async (data) => {
  try {
    const response = await Api.post(REGISTER_PATIENT_API.url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};
